import TemplateTag from "../TemplateTag/TemplateTag.js";
import stripIndentTransformer from "../stripIndentTransformer/stripIndentTransformer.js";
import trimResultTransformer from "../trimResultTransformer/trimResultTransformer.js";
var stripIndent = new TemplateTag(stripIndentTransformer, trimResultTransformer);
export {
  stripIndent as default
};
//# sourceMappingURL=stripIndent.js.map
